import React from 'react';
import { Modal } from 'react-bootstrap';
import { ModalContext } from 'context/ModalContext';
import Add_Benefit from '../forms/setup/Add_Benefit';

function AddBenefit(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add Benefit</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <NewUser/> */}
          <Add_Benefit {...props}/>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddBenefit;